/**
 * Numpad — Touch-freundliches Zahleneingabefeld.
 *
 * WARUM eigene Komponente: Auf Mobile ist System-Tastatur störend
 * (Layout-Shift, falsche Tasten). Custom-Pad = volle Kontrolle.
 */
import { el, div, button } from '../../utils/domHelpers.js';

const KEYS = [
  '1', '2', '3',
  '4', '5', '6',
  '7', '8', '9',
  '-', '0', '⌫',
];

export function createNumpad({ onInput, onDelete, onSubmit }) {
  const grid = div({ class: 'numpad-grid' });

  for (const key of KEYS) {
    const isAction = (key === '⌫' || key === '-');
    const btn = button(
      {
        class: `numpad-key${isAction ? ' numpad-key--action' : ''}`,
        type: 'button',
        onclick: () => {
          if (key === '⌫') onDelete?.();
          else onInput?.(key);
        }
      },
      [key]
    );
    grid.appendChild(btn);
  }

  // Submit-Button breit unter dem Numpad
  const submitBtn = button(
    { class: 'btn btn-primary btn-block', style: { marginTop: '12px' }, type: 'button',
      onclick: () => onSubmit?.() },
    ['Antwort senden →']
  );

  const wrapper = div({ class: 'flex-col gap-3', style: { width: '100%', maxWidth: '360px', margin: '0 auto' } }, [
    grid,
    submitBtn
  ]);

  return wrapper;
}

// Tastatur-Bindings: Desktop-Nutzer können tippen statt klicken
export function bindNumpadKeyboard({ onInput, onDelete, onSubmit }) {
  const handler = (e) => {
    if (e.key >= '0' && e.key <= '9') { onInput?.(e.key); e.preventDefault(); }
    else if (e.key === '-')           { onInput?.('-'); e.preventDefault(); }
    else if (e.key === 'Backspace')   { onDelete?.(); e.preventDefault(); }
    else if (e.key === 'Enter')       { onSubmit?.(); e.preventDefault(); }
  };
  document.addEventListener('keydown', handler);
  return () => document.removeEventListener('keydown', handler);
}
